import { render, staticRenderFns } from "./supplierCouponList.vue?vue&type=template&id=59d2cc41&scoped=true"
import script from "./supplierCouponList.vue?vue&type=script&lang=js"
export * from "./supplierCouponList.vue?vue&type=script&lang=js"
import style0 from "./supplierCouponList.vue?vue&type=style&index=0&id=59d2cc41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d2cc41",
  null
  
)

export default component.exports